import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";
import {InsolesModelSummaryModel} from "../../../../insolemodel/api/entity/insolesModelSummary.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {CamMachineSummaryModel} from "../../../../../3d/cam/machine/api/model/camMachineSummary.model";

export class ProviderCamMachineSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    camMachine: CamMachineSummaryModel;
    name: string;
    active: boolean;
    url: string;
    remoteInterfaceType: LovValueSummary;
    webUrl: string;
}